import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LazyMotion, MotionConfig } from 'framer-motion';
import { Toaster } from 'sonner';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ConsentProvider } from './context/ConsentContext';
import { ThemeProvider, useTheme } from './theme/ThemeContext';

const loadMotionFeatures = () => import('./lib/motionFeatures').then((mod) => mod.default);

function ThemedToaster() {
  const { resolved } = useTheme();
  return <Toaster position="top-center" theme={resolved} richColors closeButton toastOptions={{ className: 'font-sans' }} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
      <BrowserRouter>
        <ConsentProvider>
          <AuthProvider>
            <LazyMotion features={loadMotionFeatures}>
              <MotionConfig reducedMotion="user">
                <App />
                <ThemedToaster />
              </MotionConfig>
            </LazyMotion>
          </AuthProvider>
        </ConsentProvider>
      </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

// Offline-friendly caching of the site's own public files (see public/sw.js). Production only.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
